<template>

  <div>

    <div class="detail __type__border">
      <p class="mb-lg text-center"><label class="form-label"><input type="checkbox" v-model='displayed' v-on:change="save" >メンバーに答えを表示する</label></p>
    </div>

    <!-- use the modal component, pass in the prop -->
    <modal v-if="showModal && resultMessage" @close="showModal = false">
      <div v-if="resultMessage" slot="body" class="modal" style="display:block;">
        <p style="white-space: pre-wrap;" v-text="resultMessage"></p>
        <ul class="list-button">
          <li>
            <button class="button __type__delete" v-on:click="showModal = false">閉じる</button>
          </li>
        </ul>
      </div>
    </modal>
    <modal v-if="showModal && !resultMessage">
    </modal>

    <modal_base></modal_base>

  </div>
</template>

<script>
  Vue.component( 'modal', {template: '#modal-template'});
  import moment from 'moment';

  export default {
    components: {
    },
    props: {
      member_id: '',
      check_id: '',
      display: '',
    },

    data() {
      return {
        displayed: this.display,
        resultMessage: '',
        showModal: false,
      }
    },

    created(){
    },

    mounted() {
    },

    filters: {
      currency: function (str) {
        return str?str.toLocaleString():'';
      },
    },

    computed: {
    },

    watch: {
    },

    methods: {
      save(){
        if(this.showModal) return;

        this.showModal = true;
        this.resultMessage = '';
        axios.put('/api/price/' + this.member_id + '/' + this.check_id ,{
          'displayed': this.displayed,
        }).then(res => {
          this.resultMessage = res.data.message || '更新しました。';
          this.showModal = 'updated';
        }).catch(error => {
          let message = "";
          for (var key in error.response.data.errors) {
            for (let v of error.response.data.errors[key]){
              message += v + "\n";
            }
          }
          this.resultMessage = message || error.response.data.message || 'エラーが発生しました。';
          this.showModal = 'canceled';
        });
      }

    }

  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/PricecheckAdmin.vue